import React from 'react'
interface ISummaryRowProps {
  title: string
  value: React.ReactNode
}

const SummaryRow = ({ title, value }: ISummaryRowProps): JSX.Element => {
  return (
    <div style={{
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginTop: 10,
      paddingTop: 12,
      borderTop: '1px solid #eef1f5',
      gap: 16
    }}>
      <span style={{ fontSize: 15, color: '#20242d', fontWeight: 500 }}>{title}</span>
      <span style={{ color: '#111111', fontSize: 15, fontWeight: 600, textAlign: 'right' }}>{value}</span>
    </div>
  )
}

export default SummaryRow
